import { Component, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { TextButtonComponent } from '../text-button/text-button.component';

@Component({
  selector: 'app-reset-text-button',
  imports: [TranslocoModule, MatIcon, TextButtonComponent],
  templateUrl: './reset-text-button.component.html',
})
export class ResetTextButtonComponent {
  resetClick = output<void>();

  onResetClick(): void {
    this.resetClick.emit();
  }
}
